<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Последний шанс оставить подписку PRO"
      button-text="Оставить PRO"
      secondary-button-text="Подробнее"
      :max-width="450"
      @buttonClick="emit('confirm')"
      @secondaryButtonClick="emit('secondary')"
      @hidden="emit('hidden')"
  >
    <template #default>
      <p class="pause-final-chance-modal__text mb-2">
        Не удалось списать средства за подписку, трёхмесячный период паузы завершён, вы будете переведены на бесплатный тариф {{ formattedDate }}
      </p>
      <p class="pause-final-chance-modal__text mb-2">
        После этого станет доступна новая система тарифов с оплатой отдельных опций
      </p>
      <p class="pause-final-chance-modal__text mb-2">
        Вы сможете подключить только нужные функции в любой момент
      </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

const props = defineProps<{
    transferToFreeAt: string;
}>();

const emit = defineEmits<{
    (e: 'confirm'): void;
    (e: 'secondary'): void;
    (e: 'hidden'): void;
}>();

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const formattedDate = computed(() => {
    const date = new Date(props.transferToFreeAt);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });
});

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.pause-final-chance-modal__text {
    font-size: 14px;
}
</style>
